<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card tile :loading="isLoading">
      <dialog-toolbar
        :document="document"
        @closeDialog="dialog = false"
      />
      <v-card-text class="mt-6">
        <v-row v-if="showDebtInfo">
          <v-col v-if="kOplate">
            У контрагента долг на сумму <span class="accent--text">{{kOplate}}</span>. Ввести заявленный платеж на сумму:
          </v-col>
          <v-col v-else>
            У контрагента нет долга. Ввести заявленный платеж на сумму:
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="8"
          >
            <v-text-field
              :prefix="currencyPrefix"
              v-model="summa"
              hide-details
              type="number"
              label="Сумма"
            />
          </v-col>
          <v-col
            cols="4"
          >
            <v-select
              :items="currencies"
              v-model="currencyId"
              label="Валюта"
              :item-text="'name'"
              :item-value="'id'"
              hide-details
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-space-around">
        <v-btn
          large
          fab
          color="accent"
          v-if="shipment"
          @click="shipDocument"
        >
          <v-icon large>mdi-upload</v-icon>
        </v-btn>
        <v-btn
          large
          fab
          color="success"
          :disabled="!summa || !currencyId"
          @click="addPayment"
        >
          <v-icon large>mdi-content-save</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DocumentApi from 'app/document/api'
import dialogToolbar from './dialogToolbar'
export default {
  name: 'document',
  components: {
    dialogToolbar
  },
  data () {
    return {
      dialog: false,
      document: {},
      isLoading: false,
      showDebtInfo: true,
      shipment: false,
      summa: '',
      kOplate: '',
      currencies: [],
      currencyId: 2
    }
  },
  computed: {
    currencyPrefix () {
      let currencyRecord = this.currencies.find((record) => record.id === this.currencyId)
      return currencyRecord ? currencyRecord.prefix : ''
    }
  },
  methods: {
    async open (document, currencies, kOplate = '') {
      this.showDebtInfo = true
      this.document = document
      this.currencies = currencies
      this.currencyId = 2
      this.summa = ''
      this.kOplate = kOplate
      this.dialog = true
      if (this.kOplate) {
        this.shipment = true
      } else {
        this.shipment = false
        this.kOplate = ''
        await this.loadData()
      }
    },
    async loadData () {
      this.isLoading = true
      this.showDebtInfo = false
      try {
        let response = await DocumentApi.getDebtInfo(this.document.name, this.document.doc_id)
        this.kOplate = response.k_oplate
        this.isLoading = false
        this.showDebtInfo = true
      } catch (e) {
        this.isLoading = false
        console.log(e)
      }
    },
    async addPayment () {
      this.isLoading = true
      await DocumentApi.addPayment({
        doc_name: this.document.name,
        doc_id: this.document.doc_id,
        summa: this.summa,
        currency_id: this.currencyId
      })
      this.isLoading = false
      this.dialog = false
    },
    shipDocument () {
      this.$emit('setProcess', this.document, 5, 1)
      this.dialog = false
    }
  }
}
</script>

<style scoped>

</style>
